import React, { forwardRef } from 'react';

export const NexsetRulesIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.3333 4H13.3333V10C13.3323 10.8837 12.9807 11.731 12.3559 12.3559C11.731 12.9807 10.8837 13.3323 10 13.3333H4V15.3333C4 15.5101 3.92976 15.6797 3.80474 15.8047C3.67971 15.9298 3.51014 16 3.33333 16C3.15652 16 2.98695 15.9298 2.86193 15.8047C2.7369 15.6797 2.66667 15.5101 2.66667 15.3333V13.3333H0.666667C0.489856 13.3333 0.320286 13.2631 0.195262 13.1381C0.0702379 13.013 0 12.8435 0 12.6667C0 12.4899 0.0702379 12.3203 0.195262 12.1953C0.320286 12.0702 0.489856 12 0.666667 12H2.66667V6C2.66773 5.11627 3.01925 4.26904 3.64415 3.64415C4.26904 3.01925 5.11627 2.66772 6 2.66667H12V0.666666C12 0.489855 12.0702 0.320286 12.1953 0.195261C12.3203 0.0702372 12.4899 0 12.6667 0C12.8435 0 13.013 0.0702372 13.1381 0.195261C13.2631 0.320286 13.3333 0.489855 13.3333 0.666666V2.66667H15.3333C15.5101 2.66667 15.6797 2.7369 15.8047 2.86193C15.9298 2.98695 16 3.15652 16 3.33333C16 3.51014 15.9298 3.67971 15.8047 3.80474C15.6797 3.92976 15.5101 4 15.3333 4ZM6 4C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V4H6Z"
        fill="#031B4A"
      />
    </svg>
  );
});
